// extracted by mini-css-extract-plugin
export default {"FormInput":"FormInput__FormInput___AwmYv"};